import React from 'react'
import PropTypes from 'prop-types'
import { INSTRUMENT_TYPE_MAP } from 'utils/constants'
import { Button } from 'components/UIElements'
import TitleInfo from './TitleInfo'
import UIProperties from './UIProperties'
import OtherProperties from './OtherProperties'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'
import '../stylesheets/properties.scss'
import ReviewScreenProperties from './ReviewScreenProperties'

const MetadataBuilderPage = props => {
  const { instrument, userId, study } = props

  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })

  const { type } = instrument
  let displayType = type
  if (type === INSTRUMENT_TYPE_MAP.diary) displayType = 'diary'

  return (
    <div className='metadata page'>
      <form
        onSubmit={e => {
          e.preventDefault()
          // Save review settings, then return to the schedule the user was editing.
          // Do not force scheduleIndex=0 — that reloads schedule 1 and drops a later
          // Triggered by Visit schedule (or an unsaved new-schedule draft).
          props.onSave('schedule', undefined, undefined, {
            syncReviewSettings: true,
          })
        }}>
        <TitleInfo {...props} displayType={displayType} hasInstrumentUnification={hasInstrumentUnification} />
        <UIProperties {...props} hasInstrumentUnification={hasInstrumentUnification} />
        {hasInstrumentUnification && <ReviewScreenProperties {...props} />}
        <OtherProperties {...props} displayType={displayType} hasInstrumentUnification={hasInstrumentUnification} />
        <div className='button-list'>
          <Button type='submit' content='Next' />
        </div>
      </form>
    </div>
  )
}

export default MetadataBuilderPage

MetadataBuilderPage.propTypes = {
  instrument: PropTypes.object,
  onSave: PropTypes.func,
  stepIndex: PropTypes.number,
}
